import styled from "styled-components";
import { SwitchCard } from 'components/ui/controls/SwitchCard';
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectContent = ({content, handler}) => {

    return (
        <StyledProjectContent>
            <div className="moduleHeader">
                <span>
                    Prosjektinnhold
                </span>
                Velg hvilke aktiviteter og prosesser inngår i dette prosjektet.
            </div>
            <div className="projectContentCards">
                <SwitchCard
                    title="Vegplanlegging"
                    description='Modellering av veg, utforming av veger og gater, dimensjonering mm.'
                    icon={<MaterialIcon name='road' weight={300}/>}
                    isChecked={content.road}
                    onChange={(e) => handler?.(prev => ({...prev, road: e}))}
                />
                <SwitchCard
                    title="Skilt og vegoppmerking"
                    description='Utarbeidelse av skilt- og vegoppmerkingsplaner.'
                    icon={<MaterialIcon name='directions' weight={300}/>}
                    isChecked={content.sign}
                    onChange={(e) => handler?.(prev => ({...prev, sign: e}))}
                />
                <SwitchCard
                    title="Signal- og trafikkstyring"
                    description='Utførelse av trafikkplaner, faseplaner og arbeid med trafikksignaler.'
                    icon={<MaterialIcon name='traffic' weight={300}/>}
                    isChecked={content.signal}
                    onChange={(e) => handler?.(prev => ({...prev, signal: e}))}
                />
                <SwitchCard
                    title="Trafikkteknikk"
                    description='Dimensjonering av trafikkmengder, trafikktekniske beregninger og simuleringer.'
                    icon={<MaterialIcon name='traffic_jam' weight={300}/>}
                    isChecked={content.traffic}
                    onChange={(e) => handler?.(prev => ({...prev, traffic: e}))}
                />
                <SwitchCard
                    title="Trafikksikkerhet"
                    description='Arbeid med trafkksikkerhetstiltak og trafikksikkerhetsrevisjoner.'
                    icon={<MaterialIcon name='outdoor_garden' weight={300}/>}
                    isChecked={content.safety}
                    onChange={(e) => handler?.(prev => ({...prev, safety: e}))}
                />
                <SwitchCard
                    title="BIM"
                    description='Ansvar for BIM og administrering av stedsdefinert data.'
                    icon={<MaterialIcon name='brick' weight={300}/>}
                    isChecked={content.bim}
                    onChange={(e) => handler?.(prev => ({...prev, bim: e}))}
                />
                <SwitchCard
                    title="Modellering"
                    description='Modellering av visualiseringsobjekter, supplerende modeller mm.'
                    icon={<MaterialIcon name='3d' weight={300}/>}
                    isChecked={content.models3D}
                    onChange={(e) => handler?.(prev => ({...prev, models3D: e}))}
                />
                <SwitchCard
                    title="Dokumentarbeid"
                    description='Skriving og vedlikehold av dokumentasjon og manualer.'
                    icon={<MaterialIcon name='draft' weight={300}/>}
                    isChecked={content.document}
                    onChange={(e) => handler?.(prev => ({...prev, document: e}))}
                />
            </div>
        </StyledProjectContent>
    )
}

const StyledProjectContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};
    overflow: auto;
    
    div.moduleHeader
    {     
        span
        {
            display: block;
            font-weight: 600;
            font-size: ${({theme}) => theme.fontSize.lg};
            margin-bottom: ${({theme}) => theme.spacing.sm};
            color: ${({theme}) => theme.colors.neutralSecondaryForeground};
        }

        color: ${({theme}) => theme.colors.mutedForeground};
    }

    div.projectContentCards
    {
        display: flex;
        flex-wrap: wrap;
        gap: ${({theme}) => theme.spacing.lg};
    }
`

